import React from 'react';
import Signup from './Signup';
import model from './model';
import { PrefixField, SuffixField, TextField } from '../basic';
import { Puff } from 'react-loader-spinner';
import { lang, remCss, scssVariables as variables } from 'src/helpers';
import SVGIcon, { BASE_ICONS } from '../svg';
import LANG_CONST from 'src/helpers/lang/const';
import { DateSelects } from '../complex';
import moment from 'moment';

class SignupDoctor extends Signup {
  type = 'doctor';

  renderUsername = () => {
    const { handleChange, handleBlur } = model;
    const createState = this.getApiState();
    const { invalid } = createState;

    if (createState.error === 'URLNAME_TAKEN') {
      invalid['username'] = createState.errorMessage;
      createState.error = null;
    }
    const { clinicUsername } = this.props.usernameParams;

    return (
      <>
        <TextField
          prefixEl={<PrefixField>dr.</PrefixField>}
          suffixEl={
            <>
              {model.getApiState('checkUsername').loading ? (
                <div className={'mc-plr10 mc-mr5'}>
                  <Puff
                    color={variables['colors-mc-primary']}
                    height={remCss(25)}
                    width={remCss(25)}
                  />
                </div>
              ) : model.input('username') && !invalid['username'] ? (
                <div className={'mc-plr10 mc-mr5 mc-flex mc-flex-center'}>
                  <SVGIcon
                    outline
                    circle
                    padding={remCss(5)}
                    iconname={BASE_ICONS.CHECK}
                    fill={variables['colors-mc-primary']}
                    height={remCss(25)}
                    width={remCss(25)}
                  />
                </div>
              ) : (
                ''
              )}
              {clinicUsername && <SuffixField>.{clinicUsername}</SuffixField>}
            </>
          }
          template={6}
          name={'username'}
          type='text'
          value={model.input('username')}
          onChange={model.handleChangeForUsername}
          onBlur={handleBlur}
          label={LANG_CONST.username}
          invalid={invalid}
        />
        {model.state.usernameSuggestion && (
          <span className={'mc-label-416'}>
            {LANG_CONST.suggestion}:{' '}
            <span
              className={'mc-primary-416 mc-pointer'}
              onClick={() => {
                handleChange('username', model.state.usernameSuggestion);
              }}
            >
              dr.{model.state.usernameSuggestion}
              {clinicUsername && '.' + clinicUsername}
            </span>
          </span>
        )}
      </>
    );
  };

  renderBirthday = () => {
    const apiStateId = 'signup';
    const { handleChange } = model;
    const createState = this.getApiState();
    const { invalid } = createState;
    return (
      <div className={'mc-flex-20 mc-flex-start'}>
        <div className={'mc-flex-col mc-grow'}>
          <div className={'mc-label-418'}>{lang.t('Birthday')}</div>
          <DateSelects
            className={'mc-user-birthday'}
            onFocus={this.onFocus}
            close={false}
            template={'6'}
            minDate={moment().startOf('year').year(1900)}
            maxDate={moment().add({ years: -18 }).endOf('year')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            invalid={invalid}
            name={'birthday'}
            date={model.input('birthday')}
          />

          {invalid['birthday'] && <p className='mc-form-invalid-text'>{invalid['birthday']}</p>}
        </div>
      </div>
    );
  };
}

export default SignupDoctor;
